import React from 'react';
import Client from './../Client';
import BackofficeReportsApi from './backofficeReportsApi';
import PromotionKpiCard from './PromotionKpiCard';

class OverviewClaimsCreated extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      data: {},
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.periodMode !== this.props.periodMode) {
      this.loadData();
    }
  }

  getPeriodLabel = () => {
    const periodMode = this.props.periodMode || "last_30d";

    if (periodMode === "last_7d") return "last 7d";
    if (periodMode === "last_90d") return "last 90d";

    return "last 30d";
  };

  formatChange = (value) => {
    if (value === null || value === undefined) return "new";

    const numberValue = Number(value);

    if (Number.isNaN(numberValue)) return "new";
    if (numberValue > 0) return `+${numberValue}%`;
    if (numberValue < 0) return `${numberValue}%`;

    return "0%";
  };

  loadData = () => {
    const periodMode = this.props.periodMode || "last_30d";

    let queryData = {
      periodMode: periodMode,
    };

    let data = BackofficeReportsApi.getPromotionsKpiSummary(this.state.client, queryData);

    if (data) {
      this.setState({ data: data });
    }
  };

  render() {
    const data = this.state.data || {};

    const claimsCreated = data.claims_created || 0;
    const claimsConsumed = data.claims_consumed || 0;
    const claimsCreatedChange = data.claims_created_change;

    return (
      <PromotionKpiCard
        title="Claims issued"
        value={claimsCreated}
        badge={`${data.claims_created_consumed || 0} used from issued`}
        caption={this.getPeriodLabel()}
        change={data.claims_created_change}
      />
    );
  }
}

export default OverviewClaimsCreated;
